module.exports = __webpack_public_path__ + "img/icon-info.0b3a093f.svg";